/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountProductHistory} from '../models/AccountProductHistory';
import type {Error} from '../models/Error';

export interface GetAccountProductHistory$Request {
    accountId: number;
    startDate: string;
    endDate: string;
    groupBy?: string;
}

export interface GetAccountProductHistory$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountProductHistoryRequest = createAction<PayloadData<void, GetAccountProductHistory$Request>>('GET_ACCOUNT_PRODUCT_HISTORY__GET_ACCOUNT_PRODUCT_HISTORY__REQUEST');
export const getAccountProductHistorySuccess = createAction<PayloadData<AccountProductHistory, GetAccountProductHistory$Request>>('GET_ACCOUNT_PRODUCT_HISTORY__GET_ACCOUNT_PRODUCT_HISTORY__SUCCESS');
export const getAccountProductHistoryFailure = createAction<PayloadData<Error, GetAccountProductHistory$Request, true>>('GET_ACCOUNT_PRODUCT_HISTORY__GET_ACCOUNT_PRODUCT_HISTORY__FAILURE');

export const getAccountProductHistoryActions = [
    getAccountProductHistoryRequest,
    getAccountProductHistorySuccess,
    getAccountProductHistoryFailure
] as const;

/**
 * Get unique user counts by product from audit history
 * @param {number} meta.accountId The unique identifier of the account
 * @param {string} meta.startDate Inclusive UTC start date, no earlier than today minus 3 calendar years. Requires endDate.
 * @param {string} meta.endDate Inclusive UTC end date, on or after startDate and no later than today. Requires startDate.
 * @param {string} [meta.groupBy] Grouping for an explicit date range, defaults to DAY. Each interval shows its end state; weeks begin on Monday.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountProductHistory = (meta: GetAccountProductHistory$Request, config?: GetAccountProductHistory$Config) => {
    const TRANSPORT_GET_PARAMS = {
        startDate: meta.startDate,
        endDate: meta.endDate,
        groupBy: meta.groupBy,
    };
    return {
        CALL_API: {
            types: getAccountProductHistoryActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/users/history/by-product`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

